<h1>Pagamenti</h1>
<p class="intro">Scegli il servizio desiderato tra le opzioni sottostanti.</p>

<section class="choices" aria-label="Tipi di pagamento">
  <article class="choice choice-iscrizione">
    <div class="choice-top">
      <span class="choice-icon" aria-hidden="true"><i class="bi bi-person-vcard"></i></span>
      <span class="choice-tag">Sostegno Annuale</span>
    </div>
    <h2>Iscrizione e Quota</h2>
    <p>
      Rinnova o sottoscrivi l'adesione annuale alla Confraternita.
      Sostieni le attività ordinarie e ricevi la nuova tessera socio per l'anno in corso.
    </p>
    <a class="choice-cta" routerLink="/pagamenti/iscrizione">
      Paga quota annuale
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </a>
  </article>

  <article class="choice choice-lampade">
    <div class="choice-top">
      <span class="choice-icon" aria-hidden="true"><i class="bi bi-lightbulb"></i></span>
      <span class="choice-tag">Servizio Cimiteriale</span>
    </div>
    <h2>Lampade Votive</h2>
    <p>
      Paga il canone del servizio di luce votiva cimiteriale per i tuoi cari
      presso i cimiteri gestiti dalla Misericordia di Borgo San Lorenzo.
    </p>
    <a class="choice-cta" routerLink="/pagamenti/lampade">
      Paga canone lampade
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </a>
  </article>

  <article class="choice choice-donazione">
    <div class="choice-top">
      <span class="choice-icon" aria-hidden="true"><i class="bi bi-heart"></i></span>
      <span class="choice-tag">Solidarietà</span>
    </div>
    <h2>Donazione Libera</h2>
    <p>
      Offri un contributo per le attività di soccorso sanitario,
      acquisto di nuove ambulanze attrezzate e sostegno concreto alle famiglie
      in difficoltà del Mugello.
    </p>
    <a class="choice-cta" routerLink="/pagamenti/donazione">
      Fai una donazione
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </a>
  </article>
</section>
